import { useState } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setMessage('');

    try {
      await new Promise(resolve => setTimeout(resolve, 1000));
      setMessage('Obrigado por se inscrever! Você receberá nossas ofertas em breve.');
      setEmail('');
    } catch (error) {
      setMessage('Erro ao se inscrever. Tente novamente.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-16 bg-gradient-to-r from-neon-pink via-neon-purple to-neon-cyan relative overflow-hidden">
      <div className="absolute inset-0 bg-gray-950/80"></div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center text-white">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 animate-glow">
            Receba Nossas Ofertas Exclusivas
          </h2>
          <p className="text-lg mb-8 text-gray-300">
            Cadastre-se e seja o primeiro a saber sobre promoções e lançamentos
          </p>

          <form onSubmit={handleSubmit} className="max-w-md mx-auto">
            <div className="flex flex-col sm:flex-row gap-3">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Seu melhor e-mail"
                required
                className="flex-1 px-6 py-4 rounded-lg bg-gray-900 text-white border border-gray-700 focus:outline-none focus:border-neon-cyan focus:shadow-neon-cyan text-sm placeholder-gray-500"
              />
              <button
                type="submit"
                disabled={isSubmitting}
                className="bg-gradient-to-r from-neon-pink to-neon-cyan hover:shadow-neon-pink text-white px-8 py-4 rounded-lg font-semibold transition-all whitespace-nowrap cursor-pointer disabled:opacity-50"
              >
                {isSubmitting ? 'Enviando...' : 'Inscrever-se'}
              </button>
            </div>
            {message && (
              <p className="mt-4 text-sm text-white bg-gray-900/80 rounded-lg py-2 px-4 border border-neon-green">
                {message}
              </p>
            )}
          </form>
        </div>
      </div>
    </section>
  );
}
